import { Injectable } from '@angular/core';

@Injectable()
export class EmployeeCredentials {
  public EmployeeNo: string = '';
  public LastName: string = '';
}
